module.exports = __webpack_public_path__ + "static/media/Air43_in.6c62fdfd.jpg";